import { ThunkType } from "../../../../core/store/reducers";
import { getTradeListReport } from "../api/getTradeListReport";
import fileDownload from "js-file-download";
import { setPrintTradeFetchState } from "../tradesDataSlice";

export const downloadTradesReport = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const filter = store.ux.domestic.trades.filter;
	const user = store.data.auth.current.user;
	dispatch(setPrintTradeFetchState({ type: "started" }));
	const tradeBookReport = await dispatch(getTradeListReport(user, filter));
	if (tradeBookReport) {
		fileDownload(new Blob([tradeBookReport as any], { type: "application/pdf" }), "TradeBook.pdf");
	}
	dispatch(setPrintTradeFetchState({ type: "not-started" }));
};
